// extracted by mini-css-extract-plugin
export default {"form":"VuB3L","field":"dj8kT","button":"zcU7k"};